module.exports = __webpack_public_path__ + "media/savings_calculator/join_today_widget-2758b691.png";